/** Segmentos de rota relativos, usados tanto pelo `RouteObject.path` de cada feature quanto pelo tipo `AppPath` abaixo. */
export const PATHS = {
  home: '',
  support: 'support',
  faq: 'faq',
  notFound: 'nao-encontrado',
} as const;

export type PathKey = keyof typeof PATHS;

/** União de todas as rotas absolutas registradas — único formato aceito por `useAppNavigate` e pelos `<Link to>` do app. */
export type AppPath = `/${(typeof PATHS)[PathKey]}`;

/** Alvo de navegação: uma rota registrada, opcionalmente com query string. */
export type AppTo = AppPath | { pathname: AppPath; search?: string };
